import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import type { CardSectionTypes } from '@etg/wings';
import { Card, Text, Stack } from '@etg/wings';

interface CartContactInfoProps extends CardSectionTypes {
  children: ReactNode;
  className?: string;
  id: string;
  label: string;
}

const CartContactInfo = ({ children, className, id, label }: CartContactInfoProps) => {
  return (
    <Card.Section className={className}>
      <Stack spacing={8}>
        <Text as="p" data-testid={`${id}-label`} id={`${id}-heading-id`} variant="18-emphasized">
          {label}
        </Text>
        <Stack aria-labelledby={`${id}-heading-id`} as="ul" data-testid={id} spacing={4}>
          {children}
        </Stack>
      </Stack>
    </Card.Section>
  );
};

interface InfoRowProps extends ComponentPropsWithoutRef<'li'> {
  content: ReactNode;
}

const InfoRow = ({ content, ...rest }: InfoRowProps) => {
  return <li {...rest}>{content}</li>;
};

type CompoundedType = typeof CartContactInfo & {
  Row: typeof InfoRow;
};

CartContactInfo.Row = InfoRow;
export default CartContactInfo as CompoundedType;
